var link_viewer_default = {
  "fontElementMap": "pZ7UF",
  "link": "DaX-R",
  "linkInEditor": "v9m6J",
  "linkInViewer": "XkeCQ",
  "toolbarUrlContainer": "VAl2d",
  "toolbarUrl": "lTVB1",
  "toolbarUrlAnchor": "LTuCA"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
